// React
import React from 'react';

// Vendors
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Src
import { ReactComponent as Logo } from '@/assets/logo-equisoft.svg';

// Styles
import classes from './TheCanvasHeader.module.scss';

const TheCanvasHeader = () => {
    // Hooks
    const { t } = useTranslation();

    return (
        <header className={classes.Root}>
            <Link
                to="/"
                className={classes.LogoWrapper}
            >
                <Logo />
                <div className={classes.LogoTitle}>
                    {t('common.logo_title')}
                </div>
            </Link>
        </header>
    );
};

export default TheCanvasHeader;
